import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { API_PORTALEFORNITORI } from '../../config/api.config';
import { DocumentoDashboardResponse, DocumentoRequest, DocumentoResponse, DocumentoTableResponse, PageDocumentoResponse } from '../../interfaces/api/portalefornitori.interface';
import { BaseApiService } from '../base-api.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentoService extends BaseApiService<typeof API_PORTALEFORNITORI.documento> {
  protected readonly baseUrl = `${environment.backend.baseUrl_portalefornitori}`;
  protected readonly config = API_PORTALEFORNITORI.documento;

  searchQuery(queryParams?: any): Observable<PageDocumentoResponse> {
    return this.request('searchQuery', { queryParams });
  }

  search(queryParams?: any): Observable<PageDocumentoResponse> {
    return this.request('search', { queryParams });
  }

  getById(id: string): Observable<DocumentoResponse> {
    return this.request('getById', {
      params: { id }
    });
  }

  create(payload: DocumentoRequest): Observable<DocumentoResponse> {
    return this.request('create', { body: payload });
  }

  update(id: string, payload: DocumentoRequest): Observable<DocumentoResponse> {
    return this.request('edit', {
      params: { id },
      body: payload
    });
  }

  countNear(): Observable<number> {
    return this.request('countNear');
  }

  countNearList(): Observable<DocumentoDashboardResponse[]> {
    return this.request('countNearList');
  }

  
  valida(id: string,valid:any): Observable<void> {
    return this.request('valida', { 
      params: { id },
      queryParams: {valid: valid}
    });
  }

  sollecita(id: string): Observable<void> {
    return this.request('sollecita', { params: { id } });
  }

  download(id: string): Observable<Blob> {
    let url = `${this.baseUrl}/${this.config.download.path}`;
    url = url.replace(`{id}`, id);
    return this.http.get(url, {
      responseType: 'blob',
      headers: { 'Accept': 'application/octet-stream' }
    });
  }

  renewal(obj: DocumentoTableResponse):Observable<DocumentoResponse> { 
    let request:DocumentoRequest = {
      type: obj.typeId,
      dueDate:'',
      mandatory: obj.mandatory,
      fornitoreId: obj.fornitoreId
    };
    return this.create(request);
  }



  archivia(id: string): Observable<void> {
    return this.request('archivia', { params: { id } });
  }

}